import { render, staticRenderFns } from "./YearSelector.vue?vue&type=template&id=bbfa12d8&scoped=true&"
import script from "./YearSelector.vue?vue&type=script&lang=js&"
export * from "./YearSelector.vue?vue&type=script&lang=js&"
import style0 from "./YearSelector.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./YearSelector.vue?vue&type=style&index=1&id=bbfa12d8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbfa12d8",
  null
  
)

export default component.exports